module.exports = __webpack_public_path__ + "img/circle5.4166f835.png";